"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAddressWithBtcInstance = void 0;
var hw_app_btc_1 = __importDefault(require("@ledgerhq/hw-app-btc"));
var logs_1 = require("@ledgerhq/logs");
var errors_1 = require("@ledgerhq/errors");
var getBitcoinLikeInfo_1 = __importDefault(require("../../hw/getBitcoinLikeInfo"));
var derivation_1 = require("../../derivation");
var errors_2 = require("../../errors");
var oldP2SH = {
    digibyte: 5
};
var getAddressWithBtcInstance = function (transport, btc, _a) {
    var currency = _a.currency, path = _a.path, verify = _a.verify, derivationMode = _a.derivationMode, forceFormat = _a.forceFormat, skipAppFailSafeCheck = _a.skipAppFailSafeCheck;
    return __awaiter(void 0, void 0, void 0, function () {
        var format, result, e_1, bitcoinAddress, publicKey, chainCode, bitcoinLikeInfo, res, P2SH, P2PKH;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    format = forceFormat || (0, derivation_1.getAddressFormatDerivationMode)(derivationMode);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, btc.getWalletPublicKey(path, {
                            verify: verify,
                            format: format
                        })];
                case 2:
                    result = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    // TODO Should normalize error returned from ledgerjs
                    if (e_1 &&
                        e_1.message &&
                        (e_1.message.includes("invalid format") ||
                            e_1.message.includes("Unsupported address format"))) {
                        throw new errors_2.UnsupportedDerivation();
                    }
                    throw e_1;
                case 4:
                    bitcoinAddress = result.bitcoinAddress, publicKey = result.publicKey, chainCode = result.chainCode;
                    if (!!skipAppFailSafeCheck) return [3 /*break*/, 6];
                    bitcoinLikeInfo = currency.bitcoinLikeInfo;
                    if (!bitcoinLikeInfo) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, getBitcoinLikeInfo_1["default"])(transport)];
                case 5:
                    res = _b.sent();
                    if (res) {
                        P2SH = res.P2SH, P2PKH = res.P2PKH;
                        if (P2SH !== bitcoinLikeInfo.P2SH || P2PKH !== bitcoinLikeInfo.P2PKH) {
                            if (currency.id in oldP2SH &&
                                P2SH === oldP2SH[currency.id] &&
                                P2PKH === bitcoinLikeInfo.P2PKH) {
                                (0, logs_1.log)("hw", "getAddress ".concat(currency.id, " app is outdated. P2SH=").concat(P2SH, " P2PKH=").concat(P2PKH));
                                throw new errors_1.UpdateYourApp("UpdateYourApp ".concat(currency.id), currency);
                            }
                            (0, logs_1.log)("hw", "getAddress ".concat(currency.id, " app is wrong. P2SH=").concat(P2SH, " P2PKH=").concat(P2PKH));
                            throw new errors_1.BtcUnmatchedApp("BtcUnmatchedApp ".concat(currency.id), currency);
                        }
                    }
                    _b.label = 6;
                case 6:
                    (0, logs_1.log)("hw", "getAddress ".concat(currency.id, " path=").concat(path, " address=").concat(bitcoinAddress, " publicKey=").concat(publicKey, " chainCode=").concat(chainCode));
                    return [2 /*return*/, {
                            address: bitcoinAddress,
                            path: path,
                            publicKey: publicKey,
                            chainCode: chainCode
                        }];
            }
        });
    });
};
exports.getAddressWithBtcInstance = getAddressWithBtcInstance;
var resolver = function (transport, opts) {
    return (0, exports.getAddressWithBtcInstance)(transport, new hw_app_btc_1["default"](transport), opts);
};
exports["default"] = resolver;
//# sourceMappingURL=hw-getAddress.js.map